import styled from 'styled-components';

/* Reusable Styles */
export const FlexContainer = styled.div`
  display: flex;
  ${p => ({ ...(p.height && { height: p.height }) })};
  justify-content: ${p => (p.justifyContent ? p.justifyContent : 'flex-start')};
  align-items: ${p => (p.alignItems ? p.alignItems : 'center')};
  flex-direction: ${p => (p.flexDirection ? p.flexDirection : 'row')};
  flex-wrap: ${p => (p.flexWrap ? p.flexWrap : 'nowrap')};
  padding: ${p => (p.padding ? p.padding : 0)};
  margin: ${p => (p.margin ? p.margin : 0)};
`;

export const Text = styled.p`
  color: ${p => (p.color ? p.color : '#404040')};
  font-size: ${p => (p.fontSize ? p.fontSize : 14)}px;
  font-weight: ${p => (p.fontWeight ? p.fontWeight : 400)};
  line-height: ${p => (p.lineHeight ? p.lineHeight : 22)}px;
  opacity: ${p => (p.opacity ? p.opacity : 1)};
  margin: ${p => (p.margin ? p.margin : 0)};
  padding: ${p => (p.padding ? p.padding : 0)};
  white-space: ${p => (p.whiteSpace ? p.whiteSpace : 'normal')};
  cursor: ${p => (p.cursor ? p.cursor : 'text')};
  word-break: break-word;
  ${p => ({ ...(p.overflow && { overflow: p.overflow }) })};
`;

export const TruncateText = styled.span`
  display: block;
  max-width: ${p => (p.maxWidth ? p.maxWidth + 'px' : 'initial')};
  white-space: ${p => (p.whiteSpace ? p.whiteSpace : 'nowrap')};
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ExternalLink = styled.a`
  color: ${p => (p.color ? p.color : '#417dff')};
  font-size: ${p => (p.fontSize ? p.fontSize : 14)}px;
  font-weight: ${p => (p.fontWeight ? p.fontWeight : 400)};
  line-height: ${p => (p.lineHeight ? p.lineHeight : 22)}px;
  margin: ${p => (p.margin ? p.margin : 0)};
  opacity: ${p => (p.opacity ? p.opacity : 1)};
  cursor: pointer;
  &:hover {
    color: ${p => (p.color ? p.color : '#417dff')};
  }
`;
